import type { KeyboardEvent } from 'react';

// Adds Enter-key activation to the sponsored airline filter switch.
//
// The toggle is a Backpack `BpkSwitch`, which renders a native
// `<input type="checkbox">`. Native checkboxes activate on Space but not Enter,
// so keyboard users pressing Enter saw nothing happen (QUAR-1719). This handler
// restores the expected switch behaviour by triggering the change on Enter while
// leaving the native Space handling untouched.
//
// `!event.repeat` ignores OS key-repeat while Enter is held, so a held key
// activates the toggle at most once per press rather than rapidly flipping it.
export const handleToggleEnterKey =
  (onToggleChange: () => void) => (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.repeat) {
      event.preventDefault();
      onToggleChange();
    }
  };
